export enum TaskType {
	Assortment = 'load_own_assortment',
	ChooseTariff = 'choose_tariff',
	Equipment = 'create_instrument',
	Plan = 'create_plan',
	ExportPlanogram = 'export_planogram',
	Planogram = 'create_planogram'
}